import { render, staticRenderFns } from "./SingleEndorsement.vue?vue&type=template&id=5a49201c&scoped=true"
import script from "./SingleEndorsement.vue?vue&type=script&lang=ts"
export * from "./SingleEndorsement.vue?vue&type=script&lang=ts"
import style0 from "./SingleEndorsement.vue?vue&type=style&index=0&id=5a49201c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a49201c",
  null
  
)

export default component.exports